<template lang="html">
  <div class="slds-form-element slds-form-element_horizontal">
    <label class="slds-form-element__label" v-bind:for="'combobox-unique-id-'+id">{{title}}</label>

    <div v-if="tip" class="slds-form-element__icon">
      <button class="slds-button slds-button_icon" aria-describedby="help" v-on:mouseenter="showtip=true" v-on:mouseleave="showtip=false">
        <svg class="slds-button__icon" aria-hidden="true">
          <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#info"></use>
        </svg>
        <span class="slds-assistive-text">Help</span>
      </button>
      <div v-if="showtip"  class="slds-popover slds-popover_tooltip slds-nubbin_bottom-left" role="tooltip" id="help" style="position:absolute;top:-45px;left:-15px;width:170px">
        <div class="slds-popover__body">{{$t(tip)}}</div>
      </div>
    </div>

    <div class="slds-form-element__control">
      <div class="slds-combobox_container">
        <div v-on:click="show=!show" v-bind:class="{'slds-is-open': show, 'slds-combobox-picklist': !show}" class="slds-combobox slds-dropdown-trigger slds-dropdown-trigger_click " aria-expanded="false" aria-haspopup="listbox" role="combobox">

          <div class="slds-combobox__form-element slds-input-has-icon slds-input-has-icon_right" role="none">
            <input type="text" class="slds-input slds-combobox__input" v-bind:id="'combobox-unique-id-'+id" aria-controls="listbox-unique-id" autoComplete="off" role="textbox" v-bind:value="thevalue" v-bind:placeholder="placeholder" readonly="" />
            <span class="slds-icon_container slds-icon-utility-down slds-input__icon slds-input__icon_right" title="Description of icon when needed">
              <svg class="slds-icon slds-icon slds-icon_x-small slds-icon-text-default" aria-hidden="true">
                <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#down"></use>
              </svg>
              <span class="slds-assistive-text">{{title}}</span>
            </span>
          </div>

          <div id="listbox-unique-id" role="listbox" class="slds-dropdown slds-dropdown_fluid">
            <ul class="slds-listbox slds-listbox_vertical" role="presentation">
              <li v-on:click="$emit('change', option.value); show='false'" v-for="(option) in options" v-bind:key="option.value" role="presentation" class="slds-listbox__item">
                <div id="listbox-option-unique-id-01" class="slds-media slds-listbox__option slds-listbox__option_plain slds-media_small slds-media_center" role="option">
                  <span class="slds-media__figure">
                    <svg class="slds-icon slds-icon_x-small slds-listbox__icon-selected" aria-hidden="true">
                      <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#check"></use>
                    </svg>
                  </span>
                  <span class="slds-media__body">
                    <span class="slds-truncate" v-bind:title="option">{{$t(option.label)}}</span>
                  </span>
                </div>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'gnetPicklist',
  components: {

  },
  props: {
    id: String,
    value: [String, Number, Date],
    options: Array,
    title: String,
    type: String,
    tabindex: Number,
    disabled: Boolean,
    placeholder: String,
    tip: String,
    hform: Boolean
  },
  computed: {
    thevalue: function() {
      console.log('cerca=')
      if (!this.options) return '';
      var i=this.options.findIndex(function(v) {
        if (v.value==this.value) return true;
      }, this);
      console.log('cerca='+i)
      if (i>=0)
        return this.options[i].label;
      return '';
    }
  },
  data() {
    return {
      show: false,
      showtip:false
    }
  },
  async created() {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>

</style>
